/**
 * Service pour récupérer la configuration publique de l'application.
 * @module services/appConfigService
 */

import { API_BASE_URL } from '../config/constants';

let cachedConfig = null;
let cacheTimestamp = 0;
const CACHE_TTL_MS = 60 * 1000; // 1 minute

/**
 * Récupère la configuration publique (accountCreationEnabled, paymentsEnabled, maintenanceMode).
 * @param {Object} options - Options
 * @param {boolean} [options.skipCache] - Ignorer le cache (utile pour vérifier le mode maintenance)
 * @returns {Promise<{ accountCreationEnabled: boolean, paymentsEnabled: boolean, maintenanceMode: boolean }>}
 */
export async function getPublicConfig(options = {}) {
  const skipCache = options.skipCache === true;

  if (!skipCache && cachedConfig && Date.now() - cacheTimestamp < CACHE_TTL_MS) {
    return cachedConfig;
  }
  try {
    const response = await fetch(`${API_BASE_URL}/config/public`, {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    const data = await response.json();
    if (data.success) {
      const config = {
        accountCreationEnabled: data.accountCreationEnabled !== false,
        paymentsEnabled: data.paymentsEnabled !== false,
        maintenanceMode: data.maintenanceMode === true,
        premiumFeatureGating:
          data.premiumFeatureGating &&
          typeof data.premiumFeatureGating === 'object' &&
          !Array.isArray(data.premiumFeatureGating)
            ? data.premiumFeatureGating
            : null,
      };
      if (!skipCache) {
        cachedConfig = config;
        cacheTimestamp = Date.now();
      }
      return config;
    }
  } catch (err) {
    console.warn('Erreur chargement config publique:', err);
  }
  return {
    accountCreationEnabled: true,
    paymentsEnabled: true,
    maintenanceMode: false,
    premiumFeatureGating: null,
  };
}

/**
 * Vérifie si l'application est en mode maintenance (sans cache long).
 * @returns {Promise<boolean>}
 */
export async function isMaintenanceMode() {
  const config = await getPublicConfig({ skipCache: true });
  return config.maintenanceMode;
}
